import React, { useCallback, useEffect, useState } from "react";
import EventsCalendar from "./EventsCalendar";
import { connect } from "react-redux";
import { token } from "../../../../modules/auth";
import {
  createIndustryEvent,
  deleteEvent,
  deleteIndustryEvent,
  editIndustryEvent,
  fetchCorporateEvents,
  fetchCountries,
  fetchIndustryEvents,
  fetchOwnEvents,
  fetchPublicEvents,
  unloadBookedEvents,
  unloadIndustryEvents,
  unloadOwnEvents,
  unloadPublicEvents,
} from "../../../../redux/actions";
import {
  mapBookedEventToCalendarEvent,
  mapEventToCalendarEvent,
} from "./mapEvents";
import { isRoleEdgeAdmin } from "../../../../modules/permissions";

const EventsContainer = ({
  industryEvents,
  publicEvents,
  ownEvents,
  bookedEvents,
  countries,
  token,
  createIndustryEvent,
  editIndustryEvent,
  company_id,
  fetchPublicEvents,
  fetchIndustryEvents,
  fetchOwnEvents,
  unloadPublicEvents,
  unloadIndustryEvents,
  unloadBookedEvents,
  unloadOwnEvents,
  fetchCorporateEvents,
  deleteEvent,
  fetchCountries,
  isRoleEdgeAdmin,
  isFetchingBookedEvents,
}) => {
  const currentDate = new Date();
  const [dateRangeForFetch, setDateRangeForFetch] = useState([
    new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
      .toISOString()
      .split("T")[0],
    new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
      .toISOString()
      .split("T")[0],
  ]);
  const [activeFilter, setActiveFilter] = useState(
    isRoleEdgeAdmin ? "all" : "ownEvents"
  );

  useEffect(() => {
    fetchPublicEvents(token);
    if (company_id) {
      fetchIndustryEvents(token, company_id);
      fetchCorporateEvents(token, { company_id, dateRange: dateRangeForFetch });
    }
    fetchCountries(token);

    return () => {
      unloadEvents();
    };
  }, []);

  useEffect(() => {
    if (activeFilter === "companyEvents" || activeFilter === "all") {
      fetchCorporateEvents(token, { company_id, dateRange: dateRangeForFetch });
    }
  }, [dateRangeForFetch, activeFilter]);

  const [event, setEvent] = useState({});
  const newEventHandler = formValues => {
    return createIndustryEvent(formValues, token);
  };

  const unloadEvents = () => {
    unloadIndustryEvents();
    unloadBookedEvents();
    unloadPublicEvents();
    unloadOwnEvents();
  };

  const editEventHandler = formValues => {
    const { id } = event;
    return editIndustryEvent(id, formValues, token);
  };

  const deleteEventHandler = () => {
    const { id } = event;
    return deleteEvent(id, token);
  };

  const fetchPublicEventsHandler = () => {
    unloadEvents();
    return fetchPublicEvents(token);
  };

  const fetchIndustryEventsHandler = () => {
    unloadEvents();
    if (company_id) {
      return fetchIndustryEvents(token, company_id, {
        dateRange: dateRangeForFetch,
      });
    }
  };

  const fetchOwnEventsHandler = () => {
    unloadEvents();
    return fetchOwnEvents(token);
  };

  const fetchCorporateEventsHandler = () => {
    unloadEvents();
    if (company_id) {
      return fetchCorporateEvents(token, {
        company_id,
        dateRange: dateRangeForFetch,
      });
    }
  };

  let events = [];
  let bookedEventsArray = [];
  let publicEventsArray = [];
  let ownEventsArray = [];

  if (Object.keys(industryEvents).length > 0) {
    events = industryEvents.map(industryEvent => {
      return mapEventToCalendarEvent(industryEvent, "industry");
    });
  }
  if (Object.keys(publicEvents).length > 0) {
    publicEventsArray = publicEvents.map(publicEvent => {
      return mapEventToCalendarEvent(publicEvent, "public");
    });
  }
  if (Object.keys(bookedEvents).length > 0) {
    bookedEventsArray = bookedEvents.map(bookedEvent => {
      return mapBookedEventToCalendarEvent(bookedEvent);
    });
  }
  if (ownEvents && Object.keys(ownEvents).length > 0) {
    ownEventsArray = ownEvents.map(ownEvent => {
      return mapBookedEventToCalendarEvent(ownEvent);
    });
  }

  Array.prototype.push.apply(events, bookedEventsArray);
  Array.prototype.push.apply(events, ownEventsArray);
  Array.prototype.push.apply(events, publicEventsArray);

  const handleNavigate = useCallback((date, view) => {
    const givenDate = new Date(date);
    const lastMonth = new Date(
      givenDate.getFullYear(),
      givenDate.getMonth() - 1,
      1
    );
    const nextMonth = new Date(
      givenDate.getFullYear(),
      givenDate.getMonth() + 2,
      0
    );
    setDateRangeForFetch([
      lastMonth.toISOString().split("T")[0],
      nextMonth.toISOString().split("T")[0],
    ]);
  }, []);

  return (
    <EventsCalendar
      calendarEvents={events}
      setActiveFilter={setActiveFilter}
      activeFilter={activeFilter}
      countries={countries}
      onNewEvent={newEventHandler}
      onEditEvent={editEventHandler}
      handleDeleteEvent={deleteEventHandler}
      company_id={company_id}
      handleNavigate={handleNavigate}
      token={token}
      setEvent={setEvent}
      isFetchingBookedEvents={isFetchingBookedEvents}
      fetchPublicEvents={fetchPublicEventsHandler}
      fetchCorporateEvents={fetchCorporateEventsHandler}
      fetchIndustryEvents={fetchIndustryEventsHandler}
      fetchOwnEvents={fetchOwnEventsHandler}
    />
  );
};

const mapStateToProps = (state, props) => ({
  ...state.industryEvents,
  ...state.publicEvents,
  ...state.countries,
  ...state.events,
  ...state.bookedEvents,
  ...state.ownEvents,
  token: token(state),
  isRoleEdgeAdmin: isRoleEdgeAdmin(state.auth),
  // company_id:  props.account && props.account.company ? props.account.company.id : '',
  company_id:
    props.account && props.account.company
      ? props.account.company.id
      : state?.auth?.user?.company_id,
});

const mapDispatchToProps = {
  fetchIndustryEvents,
  fetchPublicEvents,
  deleteIndustryEvent,
  fetchCountries,
  createIndustryEvent,
  editIndustryEvent,
  unloadIndustryEvents,
  unloadPublicEvents,
  fetchCorporateEvents,
  unloadBookedEvents,
  fetchOwnEvents,
  unloadOwnEvents,
  deleteEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsContainer);
